/*
 * @Author: Merlin
 * @Date: 2024-01-17 14:36:14
 * @LastEditors: Merlin
 * @LastEditTime: 2024-01-17 14:37:19
 * @Description: 
 */
import step01 from '../img/rule01.png';
import step02 from '../img/rule02.png';
import step03 from '../img/rule03.png';
import mobile_step01 from '../img/mobile_rule01.png';
import mobile_step02 from '../img/mobile_rule02.png';
import mobile_step03 from '../img/mobile_rule03.png';

export const aRouletteRule = [{
    content1: 'roulette.ruleDesc01',
    constent2: '',
    img: step01,
    imgMobile: mobile_step01,
}, {
    content1: 'roulette.ruleDesc02',
    constent2: '',
    img: step02,
    imgMobile: mobile_step02,
}, {
    content1: 'roulette.ruleDesc03',
    constent2: '',
    img: step03,
    imgMobile: mobile_step03,
},];





